import React from 'react';
import '../Style/button.css';

const ButtonHtmlView = ({onKeyUp, onKeyDown, onKeyPress, disabled, disableOnClick, classNameDisable, children, id}) => (
    <button
        role='button'
        id={id ? id : null}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        onKeyPress={onKeyPress}
        disabled={disabled}
        onClick={disableOnClick}
        className={classNameDisable}>
        {children}
    </button>
);

const ButtonView = (props) => <>{props.classNameDiv ? <div className={props.classNameDiv}><ButtonHtmlView {...props} /></div> : <ButtonHtmlView {...props} />}</>;

export default ButtonView;
